import { AppAction } from 'actions/types/ActionTypes'
import equal from 'fast-deep-equal'
import { v4 as uuidV4 } from 'uuid'
import { BUSINESS_TRAVELLER_ACTIONS } from 'reducers/businessTravellerActionReducer'

function setSelectedBusinessTravellersAndGuests(employeeIds: Array<string> | undefined, guestCount?: number): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    // We want to generate a guestId whenever the guest count is changed.
    // The guestIds are used on the checkout to associate the guests.
    // it allows us to move guests between rooms and keep them associated with the traveller form.
    // Have left the guestCount unchanged as it is used all through the search flow.
    // Maybe this can be consolidated in the future.
    const currentGuestCount = state.businessTraveller.selectedTravellerGuestCount
    const currentGuestIds = state.businessTraveller.selectedTravellerGuestIds || []

    let guestIds: Array<string> | undefined
    if (guestCount !== undefined && guestCount !== currentGuestCount) {
      if (guestCount > currentGuestCount) {
        const additionalGuests = guestCount - currentGuestCount
        const newGuestIds = Array.from({ length: additionalGuests }, () => `${uuidV4()}`)
        guestIds = [...currentGuestIds, ...newGuestIds]
      } else {
        guestIds = currentGuestIds.slice(0, guestCount)
      }
    } else if (guestCount === currentGuestCount) {
      guestIds = currentGuestIds
    }

    if (!equal(employeeIds, state.businessTraveller.selectedTravellerEmployeeIds) || guestCount !== state.businessTraveller.selectedTravellerGuestCount) {
      dispatch({
        type: BUSINESS_TRAVELLER_ACTIONS.SET_BUSINESS_TRAVELLER,
        employeeIds,
        guestCount,
        guestIds,
      })
    }
  }
}

export default setSelectedBusinessTravellersAndGuests
